// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"0":"26517638","101":"28747662","358":"4058ee7f","502":"6d666874","530":"7503b45b","736":"41d19ae4","863":"966d5529","949":"770ca7f3"}[chunkId] + ".js";
};